import { useEffect, useState } from 'react';
import { supabase } from '../lib/supabase';
import { useAuth } from '../contexts/AuthContext';

export function useRole() {
  const { user } = useAuth();
  const [role, setRole] = useState(null);
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user) {
      setRole(null);
      setProfile(null);
      setLoading(false);
      return;
    }

    async function fetchRole() {
      try {
        const { data, error } = await supabase
          .from('profiles')
          .select('*')
          .eq('id', user.id)
          .single();

        if (data) {
          setRole(data.role);
          setProfile(data);
        } else {
          setRole('teacher');
          setProfile(null);
        }
      } catch (e) {
        setRole('teacher');
        setProfile(null);
      }
      setLoading(false);
    }

    fetchRole();
  }, [user]);

  const isOwner = role === 'owner';
  const isExecutive = role === 'executive' || role === 'owner';
  const isAdmin = isOwner || isExecutive;

  return {
    role,
    profile,
    loading,
    isAdmin,
    isOwner,
    isExecutive,
    isTeacher: role === 'teacher',
  };
}